import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TermanService } from 'src/app/services/terman.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-terman',
  templateUrl: './create-terman.component.html',
  styles: [
  ]
})
export class CreateTermanComponent implements OnInit {

  public type;
  public numbers=[1,2,3,4,5,6,7,8,9,10];

  public termanForm = this.fb.group({
    title: [''],
    serie:[''],
    opcA: this.fb.group({
        text:[''],
        value:['']
    }),
    opcB: this.fb.group({
        text:[''],
        value:['']
    }),
    opcC: this.fb.group({
        text:[''],
        value:['']
    }),
    opcD: this.fb.group({
        text:[''],
        value:['']
    }),
    opcE: this.fb.group({
        text:[''],
        value:['']
    }),
    pair: this.fb.group({
        text:[''],
        value:[''],
    }),
    doubleSelection:this.fb.group({
        opcA: this.fb.group({
          text:[''],
          value:false
      }),
      opcB: this.fb.group({
          text:[''],
          value:false
      }),
      opcC: this.fb.group({
          text:[''],
          value:false
      }),
      opcD: this.fb.group({
          text:[''],
          value:false
      }),
      opcE: this.fb.group({
          text:[''],
          value:false
      }),
    }),
    numbers: this.fb.group({
        text:[''],
        value:[''],

    }),
    textNumbers: this.fb.group({
        text:[''],
        firstValue:[''],
        secondValue:['']
        
    }),
    boolean: this.fb.group({
        text:[''],
        value:['']
    }),

  })
  constructor(private fb:FormBuilder, private termanService:TermanService) { }

  ngOnInit(): void {
  }

  setSelectedPart(e){
    this.type = e.target.value;
///////////////////////////serie 6 y 8 letra a boolean////////////////////
  }

  register(){
    if (this.type=="6"){

      if(this.termanForm.get(['boolean','value']).value.toUpperCase()!="N"&&this.termanForm.get(['boolean','value']).value.toUpperCase()!="S"){
        alert("Verifique el formato de los caracteres");
      }else{
        if(this.termanForm.get(['boolean','value']).value.toUpperCase()=="S"){
          this.termanForm.get(['boolean','value']).setValue(true);
          console.log(this.termanForm.value);
        }else{
          this.termanForm.get(['boolean','value']).setValue(false);
          console.log(this.termanForm.value);

        }
      }
    }

    if (this.type=="8"){

      if(this.termanForm.get(['boolean','value']).value.toUpperCase()!="F"&&this.termanForm.get(['boolean','value']).value.toUpperCase()!="V"){
        alert("Verifique el formato de los caracteres");
      }else{
        if(this.termanForm.get(['boolean','value']).value.toUpperCase()=="V"){
          this.termanForm.get(['boolean','value']).setValue(true);
          console.log(this.termanForm.value);
        }else{
          this.termanForm.get(['boolean','value']).setValue(false);
          console.log(this.termanForm.value);

        }
      }
    }

    if(this.termanForm.get(['boolean','value']).value=='') this.termanForm.get(['boolean','value']).setValue(false);

    this.termanService.createQuestion(this.termanForm.value).subscribe(
      resp=>{
        this.termanForm.reset();
        let timerInterval
        Swal.fire({
          title: 'Pregunta creada',
          html: '',
          timer: 1000,
          timerProgressBar: true,
          willOpen: () => {
            Swal.showLoading()
          },
          onClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            window.location.reload();
          }
        })
      },
      err=>{
        console.log(err);
      }
    )
  }

  reset(){
    this.termanForm.reset();
  }
}
